export default __webpack_public_path__ + "static/media/sdg-12-load.b9f7dd1e.png";